//Built-In
import React, {Fragment} from 'react';

//External
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { Button } from "reactstrap";
import CratioTooltip from "../../Common/CratioTooltip";
//Internal
import CommonHeaderContent from "../../Common/CommonHeaderContent";
import Common from "../../Common/Common";
import CampaignList from "./CampaignList";
import {
    confirmBoxWithImage, getSessionValue, getTemplateInfo,
    getTemplatesFormDetails, handleErrorResponse,
    populateCurrentFormDetail, showToast, validateRestrictedActions,
    setSessionValue,parseJSON,
    getFormNameandLabel
} from "../../Common/Appcommon";
import requestApi from "../../services/requestApi.service";
import cx from "classnames";
import {faCirclePlay} from "@fortawesome/free-regular-svg-icons/faCirclePlay";
import {faCircleStop} from "@fortawesome/free-regular-svg-icons/faCircleStop";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import {repeatOptions} from "../Templates/Constants";
import {Redirect} from "react-router-dom";
import automationIcon from "../../assets/utils/images/automation-active.png";
import {Controller} from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {randstr} from "../../Common/Appcommon";
import {faFloppyDisk} from "@fortawesome/free-regular-svg-icons";

class AutomationOperations extends React.Component{
    formname = process.env.REACT_APP_AUTOMATION_FORMNAME;
    formDetail = [];
    leadFormname = getSessionValue('leadformname');
    leadFormDetail = [];
    campaignFormname = process.env.REACT_APP_CAMPAIGN_FORMNAME;
    buttonClickRef = React.createRef();
    repeatConfigOptions = [];
    constructor(props) {
        super(props);
        let automationId = props.match.params.id === undefined ? '' : props.match.params.id;
        this.repeatConfigOptions.push({
            value : "Once", label : "Once"
        });
        this.repeatConfigOptions.push({
            value : "Multiple", label : "Multiple Times"
        });
        this.state = {
            formData : {},
            campaigns : [],
            campaignCount : 1,
            automationId : automationId,
            templates : [],
            formList : [],
            selectedForm : [],
            leadStartTemplate : {},
            leadExitTemplate : {},
            repeatConfigOption : this.repeatConfigOptions[0],
            newCampaignList : {},
            removeCampaignsList : {},
            activationStatus : "Inactive",
            showLoader : false,
            isChangeAutomationStatus : false,
            isCampaignModalOpen : false,
            runstitlevalue : "Runs once mean: A contact enters this automation for once, and they cannot re-enter the same automation.",
            resetAllCampVariables : false,
            validCampaigns : [],
        }
    }

    componentDidMount = async() => {
        this.setState({
            showLoader : true
        })
        this.formDetail = await this.populateFormDetail(this.formDetail, this.formname);

        await this.getFormNameByMobileNo();

        if(this.state.automationId != ""){
            await this.getCampaignList(this.state.automationId);
            await this.getAutomationInformation(this.state.automationId);
        }
        this.setState({
            showLoader : false
        })
    }

    getTemplatesByFormname = async (formname = this.leadFormname) => {
        this.leadFormDetail = await this.populateFormDetail(this.leadFormDetail, formname);

        let {templates} = await getTemplatesFormDetails(this.leadFormDetail);

        this.setState({
            templates
        })
    }

    campaignModalState = (modalState) => {
        this.setState({
            isCampaignModalOpen : modalState
        })
    }

    populateFormDetail = async(formDetail, formname) => {
        return await populateCurrentFormDetail(this.props,formDetail,formname);
    }

    getFormNameByMobileNo = async () => {

        let isEnabledList = {
            "isAddonEnabled" : true, 
            "isWsappEnabled" : true, 
            "isProfileEnabled" : true,
            "type" : "Automation",
            "isContactRef" : true
        };

        let response = await getFormNameandLabel(isEnabledList);
        if(response.issuccess){
            let data = response.data;
            this.setState({
                formList : data
            })
        }
    }

    getAutomationInformation = async(automationId) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION" : "getAutomation",
            "automationId" : automationId,
            "isOtherApiReq" : true,
            "FORMNAME" : this.formname
        }

        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            let automationData = res.data;
            if(automationData.length > 0){
                let formData = {};
                let automation = automationData[0]
                formData['automation_name'] = automation[0];
                formData['automation_description'] = automation[1];
                formData['startConditionType'] = automation[2];
                formData['start_templates'] = automation[3];
                let leadStartTemplate = await getTemplateInfo(automation[3]);
                formData['exit_templates'] = automation[4];
                let leadExitTemplate = await getTemplateInfo(automation[4]);

                //to get the template option value based on formname from db.
                let startdTemplatearray = automation[3] !== undefined && automation[3] !== null ? automation[3].split('#') : [];
                if(this.state.formList !== undefined && this.state.formList !== ''){
                    this.state.formList.map((val) => {
                        let startdTemplatename = startdTemplatearray[2] !== undefined ? startdTemplatearray[2] : this.leadFormname;
                        if(val.value == startdTemplatename){
                            this.setState({
                                selectedForm : val
                            })
                            this.getTemplatesByFormname(val.value);
                        }
                    })
                }

                let repeatConfig = await getTemplateInfo(automation[6]);
                formData['repeat_config'] = automation[6];
                let activationStatus = automation[5];
                this.setState({
                    formData, leadStartTemplate, leadExitTemplate, activationStatus, repeatConfigOption : repeatConfig
                })
                this.checkVariables();
            }
        }
    }


    // Check Template Variables is Empty
    checkVariables = (campaigns = this.state.campaigns) => {
        for(let i = 0; i < campaigns.length; i++){
            let component = campaigns[i]['Components'] !== undefined ? campaigns[i]['Components'] : '';
            component = parseJSON(component);
            if(component.body !== undefined && component.body.variables !== undefined && component.body.variables == "" && component.body.variables.length == 0){
                this.handleCampaignChanged(campaigns[i]['id']);
            }
        }
    }

    getCampaignList = async(automationId,removeIds="") => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION" : "getAllCampaigns",
            "automationId" : automationId,
            "isOtherApiReq" : true,
            "FORMNAME" : this.formname,
            "SKIPPEDIDS" : removeIds
        }

        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            let campaigns = res.data;
            this.setState({
                campaigns : campaigns,
                campaignCount : campaigns.length
            })
            this.checkVariables(campaigns);
        }
    }

    getSingleCampaign = async(campaignId) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION" : "getCampaign",
            "campaignId" : campaignId,
            "isOtherApiReq" : true,
            "FORMNAME" : this.campaignFormname
        }

        let res = await requestApi.processServerRequest(params,"WebV2","post");
        return res;
    }

    handleChange = async(e) => {
        let name = e.target.name;
        let formInputData = this.state.formData;
        formInputData[name] = e.target.value;
        this.setState({
            formData: formInputData
        })
    }

    handleTemplateChange = async(selectedTemplate, objName) => {
        if(selectedTemplate === null || selectedTemplate === 'null'){
            selectedTemplate =  {value:"",label:""}
        }
        if(selectedTemplate.value == 'Multiple'){
            this.setState({
                runstitlevalue : 'Runs multiple times means: A contact enters your automation through the same start condition each time they meet.'
            })
        }else if(selectedTemplate.value == 'Once'){
            this.setState({
                runstitlevalue : 'Runs once mean: A contact enters this automation for once, and they cannot re-enter the same automation.'
            })
        }
        if(selectedTemplate !== undefined && selectedTemplate !== null){
            let templateId = selectedTemplate.value;
            let formData = this.state.formData;

            formData[objName] = selectedTemplate.value+"#"+selectedTemplate.label+"#"+this.state.selectedForm.value;

            if (objName == "selected_form"){
                if(this.state.selectedForm !== undefined && this.state.selectedForm !== selectedTemplate){
                    if(this.state.selectedForm.value !== undefined && this.state.selectedForm !== selectedTemplate){
                        setSessionValue('validCampaignsIds', JSON.stringify([]));
                        this.setState({
                            validCampaigns : [],
                            resetAllCampVariables : true,
                        },()=>{
                            this.checkVariables();
                        });
                    }

                    this.setState({
                        selectedForm : selectedTemplate,
                        leadStartTemplate : [],
                        leadExitTemplate : [],
                        formData
                    });
                    await this.getTemplatesByFormname(selectedTemplate.value);
                }
            }else if (objName == "start_templates"){

                this.setState({
                    leadStartTemplate : selectedTemplate, formData
                })

            } else if (objName == "exit_templates"){

                this.setState({
                    leadExitTemplate : selectedTemplate, formData
                })

            } else if (objName == "repeat_config"){

                this.setState({
                    repeatConfigOption : selectedTemplate, formData
                })

            }
        } else {
            if (objName == "start_templates"){
                this.setState({
                    leadStartTemplate : {}
                })
            } else if (objName == "exit_templates"){
                this.setState({
                    leadExitTemplate : {}
                })
            } else if (objName == "repeat_config"){
                this.setState({
                    repeatConfigOption : {}
                })
            }
        }
    }

    getNewCampaignIdList = async(campaignId) => {
        if(this.state.automationId != "") {
            let removeIds = [];
            for (let key in this.state.removeCampaignsList) {
                removeIds.push(key);
            }
            await this.getCampaignList(this.state.automationId,removeIds);
        } else {
            let campaigns = this.state.campaigns;
            let newCampaignList = this.state.newCampaignList;
            let formResponse = await this.getSingleCampaign(campaignId);
            if (formResponse.issuccess) {
                let recordData = formResponse.data;
                newCampaignList[campaignId] = recordData;
                campaigns.push(recordData);
                this.setState({
                    campaigns,
                    newCampaignList,
                    campaignCount: Object.keys(newCampaignList).length
                })
            }
        }
    }

    removeDuplicates = (data) => {
        const uniqueData = Array.from(new Set(data.map(obj => obj.id))).map(id => {
            return data.find(obj => obj.id === id);
        });

        return uniqueData;
    }

    submitAutomationForm = async(e) => {
        //e.preventDefault();
        //if(e.target.name === "automation") {

        let valid = await validateRestrictedActions();
        if(!valid){
            return false;
        }

        let {formData, newCampaignList, removeCampaignsList, campaigns, automationId, resetAllCampVariables, selectedForm, validCampaigns} = this.state;
        if(!(campaigns.length > 0)){
            showToast("Add at least one message to start this automation","top-right",'warning');
            return false;
        }

        campaigns = this.removeDuplicates(campaigns);

        if(!resetAllCampVariables || (resetAllCampVariables && campaigns.length === validCampaigns.length)){
            let campaignIds = [];
            for (let key in newCampaignList) {
                campaignIds.push(key);
            }
            let removeIds = [];
            for (let key in removeCampaignsList) {
                removeIds.push(key);
            }

            if(formData['startConditionType'] === undefined){
                formData['startConditionType'] = "all_new_leads";
            }

            if(formData['startConditionType'] == 'all_new_leads'){
                formData['start_templates'] = "##"+selectedForm.value
            }
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "FORMINPUT": formData,
                "campaignIds": campaignIds,
                "isOtherApiReq": true,
                "FORMNAME": this.formname,
            }
            if (automationId === "") {
                params["OPERATION"] = "AUTOMATION_SAVE";
            } else if (automationId !== "") {
                params["OPERATION"] = "AUTOMATION_UPDATE";
                params["FORMID"] = automationId;
                params["removeIds"] = removeIds;
            }

            let res = await requestApi.processServerRequest(params, "WebV2", "post");
            if (res.issuccess) {
                if(this.state.isChangeAutomationStatus){
                    await this.updateAutomationStatus(res.data[0]);
                    this.setState({isChangeAutomationStatus : false})
                } else {
                    this.props.history.push('/automations');
                }
            } else if(res.errormsg !== ""){
                handleErrorResponse(res.errormsg);
            }
        }else{
            showToast("Please Update Campaign", "top-right", 'warning');
        }

        //}
    }

    incrementCampaignCount = async() => {
        let campaignCount = this.state.campaignCount;
        campaignCount = campaignCount + 1;
        this.setState({
            campaignCount
        })

    }

    decreaseCampaignCount = async() => {
        let campaignCount = this.state.campaignCount;
        campaignCount = campaignCount - 1;
        this.setState({
            campaignCount
        })
    }

    removeCampaign = async(campaignId) => {

        let { campaigns,campaignCount } = this.state;
        if(campaignId != "") {
            if(campaignCount > 1 && campaigns.length > 1) {
                let title = "Delete Message";
                let message = "Are you sure you want to delete the message?";
                let isConfirm = await confirmBoxWithImage(title, message);
                if(isConfirm) {
                    let updatedCList = [];
                    let removeCampaignIds = this.state.removeCampaignsList;
                    removeCampaignIds[campaignId] = campaignId;
                    for (let c = 0; c < campaigns.length; c++) {
                        let cId = campaigns[c]['id'];
                        if (cId != campaignId) {
                            updatedCList.push(campaigns[c]);
                        }
                    }

                    this.setState({
                        campaigns: updatedCList,
                        removeCampaignsList: removeCampaignIds,
                        campaignCount: campaignCount -1 //updatedCList.length
                    })

                    // valid check

                    let validCampaigns = parseJSON(getSessionValue('validCampaignsIds'));
                    validCampaigns = validCampaigns.filter(item => item !== campaignId);
                    validCampaigns = [...new Set(validCampaigns)];
                    setSessionValue('validCampaignsIds', JSON.stringify(validCampaigns));
                }
            } else {
                showToast("Can't delete this message alteast 1 message should be in automation(s)","top-right",'warning');
            }
        } else {

            if(campaignCount !== undefined && campaignCount > 1){
                await this.decreaseCampaignCount();
            }else{
                showToast("Can't delete this message alteast 1 message should be in automation(s)","top-right",'warning');
            }
        }
    }

    changeAutomationStatus = async() =>{
        await this.setState({
            isChangeAutomationStatus : true
        })
        this.saveAutomationInfo();

    }

    updateAutomationStatus = async(automationId) => {
        let currentStatus = this.state.activationStatus;

        //Don't allow to Activate campaign on sandbox mode.
        if(currentStatus !== 'Active'){
            let valid = await validateRestrictedActions();
            if(!valid){
                return false;
            }
        }

        let title = "Start Automation";
        let imageIcon = automationIcon;
        let message = "Are you sure you want to start sending messages?";
        if (currentStatus === "Active") {
            title = "Stop Automation";
            imageIcon = "";
            message = "Are you sure you want to stop sending messages?";
        }
        let isConfirm = await confirmBoxWithImage(title, message, imageIcon);
        if(isConfirm) {
            let successMsg = "";
            if (currentStatus === "Active"){
                currentStatus = "Inactive";
                successMsg = "Automation Stopped Successfully.";
            } else {
                currentStatus = "Active";
                successMsg = "Automation Started Successfully.";
            }
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "UPDATE_AUTOMATION_STATUS",
                "automationId": automationId,
                "isOtherApiReq": true,
                "FORMNAME": this.formname,
                "Status": currentStatus
            }

            let res = await requestApi.processServerRequest(params, "WebV2", "post");
            if (!res.issuccess) {
                handleErrorResponse(res.errormsg);
            } else {
                if(title !== "Stop Automation") {
                    this.props.history.push('/automations');
                }
                showToast(successMsg, 'top-right', 'success');
            }
            this.setState({
                activationStatus: currentStatus
            })
        }
    }

    saveAutomationInfo = () => {
        this.buttonClickRef.current.click();
    }

    leadRepeatOption = async (repeat) => {
        let repeatOption = repeatOptions[repeat];
        let repeatOptionValue = {
            value : repeat, label : repeatOption
        }
        return repeatOptionValue;
    }

    handleCampaignChanged = (campaignId) => {

        if(campaignId !== undefined && campaignId !== ''){

            let {validCampaigns} = this.state;
            campaignId = parseInt(campaignId);
            validCampaigns.push(campaignId);
            validCampaigns = [...new Set(validCampaigns)];
            setSessionValue('validCampaignsIds', JSON.stringify(validCampaigns));
            this.setState({
                validCampaigns : [...validCampaigns],
            });
        }

    }

    render(){

        let { controller } = this.props;
        const { register, handleSubmit, control, formState: { errors } } = this.props.useForm;
        let campaignEle = [];
        let {campaigns, resetAllCampVariables, automationId} = this.state;
        let campaignIds = Object.keys(this.state.newCampaignList);
        let selectedFormName = this.state.selectedForm.value !== undefined && this.state.selectedForm.value !== null && this.state.selectedForm.value !== '' ? this.state.selectedForm.value : '';

        for(let i = 0; i < this.state.campaignCount; i++){
            let campaign = [];
            let campaignId = "";
            if(campaignIds.length > i && this.state.automationId === "") {
                campaignId = campaignIds[i];
                campaign = this.state.newCampaignList[campaignId];
            }else if(campaigns.length > i) {
                campaign = campaigns[i];
                campaignId = campaign['id'];
            }

            let isValidCampaign = false;
            let validCampaigns = [];

            let campaignVal = getSessionValue('validCampaignsIds');

            if(campaignVal !== undefined && campaignVal !== "" && campaignVal !== null){
                validCampaigns = parseJSON(campaignVal);
            }

            let setEmptyValueVariables = true;
            if(!resetAllCampVariables || validCampaigns.includes(campaignId)){
                setEmptyValueVariables = false;
            }

            if(resetAllCampVariables){
                // Any resetAllCampVariables true
                if(validCampaigns.includes(+campaignId)){
                    isValidCampaign = true;
                }
            }else{
                // For default
                isValidCampaign = true;
            }

            campaignEle.push(
                <div>
                    <CampaignList
                        useCForm={this.props.useCForm}
                        controller={controller}
                        campaignModalState={this.campaignModalState}
                        number={i}
                        campaignId={campaignId}
                        removeCampaign={this.removeCampaign}
                        automationId={this.state.automationId}
                        incrementCampaignCount={this.incrementCampaignCount}
                        campaign={campaign}
                        getNewCampaignIdList={this.getNewCampaignIdList}
                        isLastCampaign={i==this.state.campaignCount - 1}
                        selectedFormName={selectedFormName}
                        resetAllCampVariables={setEmptyValueVariables}
                        handleCampaignChanged={this.handleCampaignChanged}
                        isValidCampaign={isValidCampaign}
                    />
                </div>
            );
        }

        let leadTemplates = this.state.templates;
        let leadTemplateOptions = [];
        leadTemplates.forEach((template,index)=> {
            if(template[11] == 1) {
                leadTemplateOptions.push({
                    value: template[0], label: template[1]
                })
            }
        });

        let buttonTxt = "Save & Close";
        let titleTxt = "Create Automation";
        let activationStatusBtn = "Save & Start";
        let buttonoutline = "success";
        let activationBtnIcon = faCirclePlay;
        if(this.state.activationStatus === "Active"){
            activationStatusBtn = "Stop Automation";
            buttonoutline = "danger";
            activationBtnIcon = faCircleStop;
        }
        if(this.state.automationId !== ""){
            //buttonTxt = "Update Automation";
            titleTxt = "Update Automation";//+this.state.formData.automation_name;
        }
        let addonButtons = [];
        if(!this.state.isCampaignModalOpen) {
            addonButtons = [
                {
                    'buttonTxt': activationStatusBtn,
                    'buttonAction': this.changeAutomationStatus,
                    'buttonOutline': buttonoutline,
                    'buttonIcon': activationBtnIcon
                }
            ]
        }
        buttonTxt = this.state.isCampaignModalOpen ? "" : buttonTxt;

        return (
            <Common pageTitle={"Automation"} showLoader={this.state.showLoader} mainContent={
                <Fragment>
                    <CommonHeaderContent
                        addonButtons={addonButtons}
                        buttonAction={this.saveAutomationInfo}
                        headerTitle={titleTxt}
                        buttonIcon={faFloppyDisk}
                        buttonOutline={'success'}
                        buttonTxt={buttonTxt}
                        cancelBtn={true}
                        cancelURL={'automations'}
                        mainContent={
                            <Fragment>
                                <div className={'newautomation-panel'}>
                                    <Row>
                                        <Col md={'12'} className={''}>
                                            <div className="container">
                                                <form name={'automation'} onSubmit={!this.state.isCampaignModalOpen ? handleSubmit(this.submitAutomationForm) : ""}>
                                                    <div className={'mt-3 vertical-timeline-without-image'}>
                                                        <Row className={'automation-section'}>
                                                            <div className={'group-header group-header-flex'}>
                                                                <div className={'automation-stepnumber'}>
                                                                    1
                                                                </div>
                                                                <span> Name your automation</span>
                                                            </div>
                                                            <Col md="10" className={'margin-left-3'}>
                                                                <label className={'automation-lbl form-label'} htmlFor="automation_name">Name</label>
                                                                <Controller
                                                                    name="automation_name"
                                                                    control={control}
                                                                    rules={{ required: (this.state.formData.automation_name === "" || this.state.formData.automation_name === undefined) ? "Please provide a automation name" : false}}
                                                                    render={({ field }) => {
                                                                        return (
                                                                            <input
                                                                                {...field}
                                                                                type="text"
                                                                                name="automation_name"
                                                                                id="automation-name"
                                                                                value={this.state.formData.automation_name}
                                                                                autoComplete={"off"}
                                                                                onChange={(e) => {
                                                                                    this.handleChange(e)
                                                                                    field.onChange(e);
                                                                                }}
                                                                                className={`form-control ${errors.automation_name ? 'is-invalid' : ''}`}
                                                                            />
                                                                        );
                                                                    }}
                                                                />
                                                                {errors.automation_name && <em className={`error invalid-feedback`}>{errors.automation_name.message}</em>}
                                                            </Col>
                                                            <Col md="10" className={'margin-left-3'}>
                                                                <label className={'automation-lbl form-label'} htmlFor="automation_description">Description</label>
                                                                <textarea value={this.state.formData.automation_description} onChange={(e) => {this.handleChange(e)}} name={'automation_description'} className={'form-control'} />

                                                            </Col>
                                                        </Row>
                                                        <Row className={'automation-section'}>
                                                            <div className={'group-header mt-3 group-header-flex'}>
                                                                <div className={'automation-stepnumber'}>
                                                                    2
                                                                </div>
                                                                <span>
                                                            Provide start condition
                                                        </span>&nbsp;
                                                                <span>
                                                            <CratioTooltip
                                                                title={'Start conditions, also known as triggers, determine how contacts are added to automation so they can proceed through your workflow.'}
                                                                id={"234"}
                                                                content={
                                                                    <FontAwesomeIcon icon={faCircleInfo}/>
                                                                }
                                                            />
                                                        </span>
                                                            </div>
                                                            <Col md={"10"} className={'margin-left-3'}>
                                                                <div className={cx('mt-1 ')}>
                                                                    <label className={'automation-lbl d-flex-alone form-label'} htmlFor="selected_form">Choose a Module</label>
                                                                    <Controller
                                                                        name="selected_form"
                                                                        control={control}
                                                                        rules={{ required: Object.keys(this.state.selectedForm).length === 0 ? "Please choose a module" : false }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <Select
                                                                                    {...field}
                                                                                    placeholder={'---Choose One---'}
                                                                                    menuPlacement={"auto"}
                                                                                    menuPosition={'fixed'}
                                                                                    name="selected_form"
                                                                                    id="selected_form"
                                                                                    className={`basic-multi-select ${errors.selected_form ? 'is-invalid' : ''}`}
                                                                                    classNamePrefix="wa-select"
                                                                                    value={Object.keys(this.state.formList).length === 0 ? false : this.state.selectedForm}
                                                                                    onChange={e => {
                                                                                        this.handleTemplateChange(e,'selected_form');
                                                                                        field.onChange(e);
                                                                                    }}
                                                                                    options={this.state.formList}
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                    {errors.selected_form && <em className={`error invalid-feedback`}>{errors.selected_form.message}</em>}
                                                                </div>
                                                                <div className={'flex-center-v mt-2'} onChange={(event => {this.handleChange(event)})}>
                                                                    <input type="radio" value="all_new_leads" className={'form-label'} checked={this.state.formData['startConditionType'] == undefined || this.state.formData['startConditionType'] == 'all_new_leads'} name="startConditionType" /> <span className={'ml-1'}> All New {this.state.selectedForm.label !== undefined ? this.state.selectedForm.label : ''}</span>
                                                                    <input type="radio" className={'ml-1 form-label'} value="template" checked={this.state.formData['startConditionType'] == 'template'} name="startConditionType" /> <span className={'ml-1'}> Based on a segment</span>
                                                                </div>

                                                                <div className={cx('mt-1 ',{'hide' : this.state.formData['startConditionType'] !== 'template'})}>
                                                                    <label className={'automation-lbl d-flex-alone form-label'} htmlFor="start_templates">Choose a Segment</label>

                                                                    <Controller
                                                                        name="start_templates"
                                                                        control={control}
                                                                        rules={{ required: this.state.formData['startConditionType'] === 'template' && Object.keys(this.state.leadStartTemplate).length === 0 ? "Start condition should not be empty" : false }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <Select
                                                                                    {...field}
                                                                                    placeholder={'---Choose One---'}
                                                                                    menuPlacement={"auto"}
                                                                                    menuPosition={'fixed'}
                                                                                    name="start_templates"
                                                                                    id="start_templates"
                                                                                    className={`basic-multi-select ${errors.start_templates ? 'is-invalid' : ''}`}
                                                                                    classNamePrefix="wa-select"
                                                                                    value={Object.keys(this.state.leadStartTemplate).length === 0 ? false : this.state.leadStartTemplate}
                                                                                    onChange={e => {
                                                                                        this.handleTemplateChange(e,'start_templates');
                                                                                        field.onChange(e);
                                                                                    }}
                                                                                    options={leadTemplateOptions}
                                                                                    isDisabled={this.state.selectedForm == '' ? true : false}
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                    {errors.start_templates && <em className={`error invalid-feedback`}>{errors.start_templates.message}</em>}
                                                                </div>

                                                                <div className={'repeat-config mt-2'}>
                                                                    <label className={'automation-lbl d-flex-alone form-label'} htmlFor="automation_description">
                                                                        Runs
                                                                        <CratioTooltip id={randstr('auto_runs_')} title={this.state.runstitlevalue} content={<FontAwesomeIcon className={'info-icon '} icon={faCircleInfo}/>} />

                                                                    </label>

                                                                    <Controller
                                                                        name="repeat_config"
                                                                        control={control}
                                                                        rules={{ required: false }}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <Select
                                                                                    {...field}
                                                                                    placeholder={'---Choose One---'}
                                                                                    menuPlacement={"auto"} menuPosition={'fixed'}
                                                                                    name="repeat_config"
                                                                                    id="repeat_config"
                                                                                    className={`basic-multi-select ${errors.repeat_config ? 'is-invalid' : ''}`}
                                                                                    classNamePrefix="wa-select"
                                                                                    value={this.state.repeatConfigOption}
                                                                                    onChange={e => {
                                                                                        this.handleTemplateChange(e,'repeat_config');
                                                                                        field.onChange(e);
                                                                                    }}
                                                                                    options={this.repeatConfigOptions}
                                                                                    isDisabled={this.state.selectedForm == '' ? true : false}
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                    {errors.repeat_config && <em className={`error invalid-feedback`}>{errors.repeat_config.message}</em>}
                                                                </div>

                                                            </Col>
                                                        </Row>
                                                        <Row className={'automation-section'}>
                                                            <div className={'group-header mt-3 group-header-flex'}>
                                                                <div className={'automation-stepnumber'}>
                                                                    3
                                                                </div>
                                                                <span> Add your messages</span>
                                                            </div>
                                                            <Col md={"10"}>
                                                                <div className={'campaigns-content'}>
                                                                    <div className={'d-flex-alone'}>
                                                                        <div className={'align-center col-md-10'}>
                                                                            <div className={'d-flex-alone col-md-12'}>
                                                                                <div className={cx('col-md-9 display-align-center')}>
                                                                                    <div className={cx('pl-1')}>
                                                                                        Message Title
                                                                                    </div>
                                                                                </div>
                                                                                <div className={cx('delay-condition col-md-3 mt-2 mb-2 d-flex-alone',) }>
                                                                                    <div className={'w-100'}>
                                                                                        <div className={cx('w-100 d-flex-alone condition-block condition-block-lbl justify-content-center ')}>
                                                                                            Send Condition
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                        <div className={'col-md-2 campaign-action-buttons justify-content-center'}>
                                                                            <div className={'form-group'}>
                                                                                <div className={'form-row-action-buttons '}>
                                                                                    Actions
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {campaignEle}
                                                            </Col>
                                                        </Row>
                                                        <Row className={'automation-section'}>
                                                            <div className={'group-header mt-3 group-header-flex'}>
                                                                <div className={'automation-stepnumber'}>
                                                                    4
                                                                </div>
                                                                <span>
                                                            Provide stop condition
                                                        </span>&nbsp;

                                                                <span>
                                                            <CratioTooltip
                                                                title={'Stop conditions, also known as goals, enable the system to automatically skip sending messages scheduled from automation once a contact meets the stop condition.'}
                                                                id={2}
                                                                content={
                                                                    <FontAwesomeIcon icon={faCircleInfo}/>
                                                                }
                                                            />
                                                        </span>
                                                            </div>
                                                            <Col md={"10"} className={'margin-left-3'}>
                                                                <div className={'mt-2'}>
                                                                    <label className={'automation-lbl form-label'} htmlFor="automation_name">Choose a Segment </label>

                                                                    <Controller
                                                                        name="exit_templates"
                                                                        control={control}
                                                                        render={({ field }) => {
                                                                            return (
                                                                                <Select
                                                                                    {...field}
                                                                                    placeholder={`---Choose One---`}
                                                                                    menuPlacement={"auto"}
                                                                                    menuPosition={'fixed'}
                                                                                    name="exit_templates"
                                                                                    id="exit_templates"
                                                                                    className={`basic-multi-select ${errors.exit_templates ? 'is-invalid' : ''}`}
                                                                                    value={Object.keys(this.state.leadExitTemplate).length === 0 ? false : this.state.leadExitTemplate}
                                                                                    classNamePrefix="wa-select"
                                                                                    onChange={e => {
                                                                                        this.handleTemplateChange(e,'exit_templates');
                                                                                        field.onChange(e);
                                                                                    }}
                                                                                    isClearable={true}
                                                                                    options={leadTemplateOptions}
                                                                                    isDisabled={this.state.selectedForm == '' ? true : false}
                                                                                />
                                                                            );
                                                                        }}
                                                                    />
                                                                    {errors.exit_templates && <em className={`error invalid-feedback`}>{errors.exit_templates.message}</em>}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div className={'mt-3 text-center hide'}>
                                                        <button ref={this.buttonClickRef} className="btn-wide mb-2 me-2 lytePrimaryBtn" size="lg" color="primary">
                                                            {buttonTxt}
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Fragment>
                        }/>
                </Fragment>
            } />
        )
    }
}

export default AutomationOperations;